module.exports = __webpack_public_path__ + "static/media/lion-banner-left.11fb822d.png";